import { AnalyticsTrackingEvent, brandclub_colors } from "@brandclub/common-ui";
import { Box, Divider, styled } from "@mui/material";

import { useEffect } from "react";
import { useNavigate } from "react-router";
import Loading from "../../../../Loading";
import { FastCheckoutState } from "../../../CheckoutMachine/types/FastCheckoutMachine";
import { getOrderTotals } from "../../../utils";

import {
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "../../../../AppNavigation/constants";

import { useFastCheckoutContext } from "../../../CheckoutMachine";

import { TotalLineItem } from "../../TotalLineItem";
import DeliverySection from "./DeliverySection";
import PaymentSection from "./PaymentSection";
import ShippingSection from "./ShippingSection";

import { useSelector } from "@xstate/react";

import AccountSection from "./AccountSection";
import CheckoutHead from "./CheckoutHead";
import RetailerSummarySection from "./RetailerSummarySection";
import ExperimentalAccountSection from "./ExperimentalAccountSection";
import { useAsyncCheckoutEnabled } from "../../CheckoutV2/hooks/useAsyncCheckoutEnabled";
import LoadingOverlay from "@/components/StoreComponents/StoreDialogs/LoadingOverlay";
import { useSiteContext } from "@/components/SiteProvider";
import { useAppSelector } from "@/redux/hooks";
import { getPurchaseDetailLink } from "@/utils/hooks/useLinkPrefix";
import { useTrackActions } from "@/utils/hooks/useTracking";
import CheckoutConfirmation from "../../CheckoutV2/CheckoutConfirmation";
const TopLevelContainer = styled(Box)({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  marginTop: 73,
  marginBottom: 73,

  ".terms": {
    fontSize: 12,
    marginTop: 20,
    opacity: 0.3,
    textAlign: "center",
    ".tosLinks": {
      color: "unset",
      "&:visited": {},
    },
  },
  ".checkout_stepper": {
    marginBottom: 5,
    marginTop: 0,
  },
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    marginTop: 40,
  },
  [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    marginTop: 40,
  },
});
const Container = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  paddingBottom: 0,
  alignItems: "center",

  gap: 20,
  ".checkout_desktop": {
    marginTop: 20,

    display: "flex",
    flexDirection: "column",
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      display: "none",
    },
  },
  ".checkout_mobile": {
    backgroundColor: "#fff",
    display: "none",
    position: "fixed",
    bottom: 0,
    left: 0,
    padding: "20px 20px 35px 20px",
    borderTop: `1px solid ${brandclub_colors.grayLight}`,
    boxSizing: "border-box",
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      display: "flex",
      flexDirection: "column",
    },
  },

  ".info": {
    flex: 1,
    width: "100%",
    ".section + .section": {
      borderTop: `1px solid ${brandclub_colors.grayLight}`,
    },
    ".section": {
      ":first-of-type": {
        paddingTop: 0,
      },
      width: "100%",
      padding: "30px 0",
      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        padding: "20px 0",
      },
      [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        padding: "20px 0",
      },
      ".section_head": {
        display: "flex",
        alignItems: "center",
        marginBottom: 16,
        position: "relative",
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
          marginBottom: 5,
        },
        [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
          marginBottom: 5,
        },
        minHeight: 35,
        ".title": {
          fontSize: 20,
          fontWeight: 600,
          flex: 1,
          [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            fontSize: 14,
            fontWeight: 500,
            opacity: 0.5,
          },
          [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
            fontSize: 14,
            fontWeight: 500,
            opacity: 0.5,
          },
        },
        ".action": {
          fontSize: 16,
          fontWeight: 500,

          "&:hover": {
            cursor: "pointer",
            textDecoration: "underline",
          },
        },
      },

      ".info_box": {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        ".info_row": {
          fontSize: 16,
          fontWeight: 500,
          lineHeight: "25px",
          display: "flex",
          alignItems: "flex-start",
          "&.address": {
            overflow: "hidden",
            WebkitLineClamp: 1,
            lineHeight: 1.5,
            height: `1.5em`, // line height * 2
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
          },
          [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
            fontSize: 14,
          },
          [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
            fontSize: 14,
          },
          ".icon": {
            width: 25,
            height: 25,
            marginRight: 8,
            objectFit: "contain",
            marginTop: 2,
            marginBottom: 2,
            [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
              width: 20,
              height: 20,
            },
            [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
              width: 20,
              height: 20,
            },
          },
        },
      },
      ".delivery": {
        marginTop: 10,
      },
      ".shipping_group_list": {
        display: "flex",
        flexDirection: "column",
        gap: 30,
      },
      ".shipping_group": {},
    },
    ".place_order_actions": {
      display: "flex",
      flexDirection: "row",
      gap: 25,
      ".order_total": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        ".title": {
          fontSize: 20,
          fontWeight: 600,
        },
        ".subtitle": {
          fontSize: 16,
          fontWeight: 500,
        },
      },
    },
  },
  ".summary": {
    // paddingTop: 30,
    display: "flex",
    flexDirection: "column",
    gap: 23,

    width: "100%",

    boxSizing: "border-box",
    [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
    [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {},
    ".breakdown": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      ">*": {
        width: "100%",
      },

      backgroundColor: "#fff",
      padding: "0px",
      borderRadius: 8,
    },
    ".summary_head": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 27,
      [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
        borderTop: `1px solid ${brandclub_colors.grayLight}`,
        paddingTop: 20,
        marginBottom: 10,
      },
      [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
        borderTop: `1px solid ${brandclub_colors.grayLight}`,
        paddingTop: 20,
        marginBottom: 10,
      },
      ".title": {
        fontSize: 20,
        fontWeight: 600,
        [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
          fontSize: 14,
          fontWeight: 500,
          opacity: 0.5,
        },
        [`@media screen and (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
          fontSize: 14,
          fontWeight: 500,
          opacity: 0.5,
        },
      },
    },
    ".summary_retailer": {
      display: "flex",
      // justifyContent: "space-between",
      alignItems: "center",
      marginBottom: 14,
      fontSize: 16,
      fontWeight: 600,
      ".logo": {
        width: 25,
        height: 25,
        marginRight: 8,
        objectFit: "contain",
      },
    },
  },
});

export const CheckoutDetail = ({
  receiptPage,
  fullWidth,
}: {
  receiptPage?: boolean;
  fullWidth?: boolean;
}) => {
  const [trackAction] = useTrackActions();

  const { routePrefix } = useSiteContext();

  const appConfig = useAppSelector((state) => state.appConfig);

  const { actorRef } = useFastCheckoutContext();
  const order = useSelector(
    actorRef,
    (snapshot) => snapshot.context.retailerCheckoutOrderStatus
  );
  const batch = useSelector(
    actorRef,
    (snapshot) => snapshot.context.checkoutBatch
  );

  const status = useSelector(
    actorRef,
    (snapshot) => snapshot.context.checkoutState
  );

  const { subtotal, shipping, tax, serviceFee, total, giftCardAmount } =
    getOrderTotals(order?.userRetailerCheckoutOrder);

  const navigate = useNavigate();
  const { enabled } = useAsyncCheckoutEnabled();

  useEffect(() => {
    if (order?.userRetailerCheckoutOrder?.orderId) {
      trackAction?.(AnalyticsTrackingEvent.CHECKOUT_SUMMARY_SCREEN_VISIT, {
        orderId: order?.userRetailerCheckoutOrder?.orderId,
        orderStatus: order?.userRetailerCheckoutOrder?.status,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order?.userRetailerCheckoutOrder?.orderId]);

  useEffect(() => {
    if (
      !order &&
      !batch &&
      status !== FastCheckoutState.LOADING &&
      status !== undefined
    ) {
      navigate("/mybag");
    }
  }, [order, batch, navigate, status]);

  const loadingPage =
    !order?.userRetailerCheckoutOrder?.retailerId ||
    (!receiptPage && status === FastCheckoutState.RECEIPT_GENERATED);

  const TopContainer = fullWidth ? Box : TopLevelContainer;

  useEffect(() => {
    if (
      order?.userRetailerCheckoutOrder &&
      receiptPage &&
      status === FastCheckoutState.RECEIPT_GENERATED
    ) {
      LoadingOverlay.close();
    } else if (
      order?.userRetailerCheckoutOrder &&
      status === FastCheckoutState.RECEIPT_GENERATED
    ) {
      LoadingOverlay.open("One moment…", "we’re finalizing your receipt");
      const purchaseDetailPageUrl = getPurchaseDetailLink(
        routePrefix,
        appConfig,
        order?.userRetailerCheckoutOrder
      );
      setTimeout(() => {
        navigate(purchaseDetailPageUrl);
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiptPage, status]);

  if (order?.showConnectPage) {
    return <CheckoutConfirmation />;
  }
  return (
    <TopContainer>
      <Container gap={12} className="checkout_main_flow_container">
        {loadingPage ? (
          <Box
            className="info"
            sx={{
              maxWidth: fullWidth ? "100%" : "776px",
            }}
          >
            <Loading dot />
          </Box>
        ) : (
          <Box
            className="info"
            sx={{
              maxWidth: fullWidth ? "100%" : "776px",
            }}
          >
            <CheckoutHead />
            {status === FastCheckoutState.RECEIPT_GENERATED ? (
              <RetailerSummarySection />
            ) : null}
            {enabled ? <ExperimentalAccountSection /> : <AccountSection />}
            <PaymentSection />
            <ShippingSection />
            <DeliverySection />
            <Box className="summary section">
              <Box className="breakdown">
                {/* Total Section */}
                <Box display="flex" flexDirection="column" gap={1}>
                  <TotalLineItem label={"Subtotal"} value={subtotal} />
                  <TotalLineItem
                    label={"Shipping fee"}
                    zeroString="Free"
                    value={shipping}
                  />
                  {giftCardAmount ? (
                    <TotalLineItem
                      label={"Gift Card"}
                      value={-giftCardAmount}
                    />
                  ) : null}
                  <TotalLineItem label={"Estimated Tax"} value={tax} />
                  <TotalLineItem label={"Service fee"} value={serviceFee} />
                  <Divider
                    sx={(theme) => ({
                      my: "8px",
                      background: theme.palette.primary.main,
                      height: "0.5px",
                    })}
                  />
                  <TotalLineItem label={"Total"} value={total} bold />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Container>
    </TopContainer>
  );
};
